module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "wrapper"
  }, [_vm._m(0, false, false), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Want to pass on your feedback, thoughts or concerns?")]), _vm._v(" "), _c('div', {
    staticClass: "petition-form wwf-form light",
    class: {
      'hide': _vm.step2
    }
  }, [_c('div', {
    staticClass: "flip-wrapper",
    class: {
      'formValidation-shake': _vm.isShake
    }
  }, [_c('div', {
    staticClass: "petition-form"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.emailAddress),
      expression: "emailAddress"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|email'),
      expression: "'required|email'"
    }],
    class: {
      'border-red': _vm.errors.has('emailAddress')
    },
    attrs: {
      "name": "emailAddress",
      "type": "email",
      "placeholder": "Email Address"
    },
    domProps: {
      "value": (_vm.emailAddress)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.emailAddress = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject),
      expression: "subject"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('subject')
    },
    attrs: {
      "name": "subject",
      "type": "text",
      "placeholder": "Subject"
    },
    domProps: {
      "value": (_vm.subject)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.subject = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('phone')
    },
    attrs: {
      "name": "phone",
      "type": "text",
      "placeholder": "Phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    class: {
      'border-red': _vm.errors.has('message')
    },
    attrs: {
      "name": "message",
      "type": "text",
      "placeholder": "Message"
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "button",
      "value": "Submit"
    },
    on: {
      "click": _vm.postTicket
    }
  })])])]), _vm._v(" "), _c('div', {
    class: {
      'hide': _vm.step1 || (_vm.step2 && _vm.serverErrors)
    }
  }, [_c('p', [_vm._v("Your message has been received by our team and we will respond as soon as possible.")])]), _vm._v(" "), _c('div', {
    class: {
      'hide': _vm.step1 || (_vm.step2 && !_vm.serverErrors)
    }
  }, [_vm._v("\n      We are sorry, an error has occurred and your request could not be submitted. Alternatively, you can contact us by email at enquiries@wwf.org.au\n      "), _c('p', {
    staticClass: "text-center hide-for-large"
  }, [_vm._v("Please tap on the orange question mark on the bottom-right of your screen")])]), _vm._v(" "), _vm._m(1, false, false), _vm._v(" "), _c('p', {
    staticClass: "text-center hide-for-large"
  }, [_vm._v("Please tap on the orange question mark on the bottom-right of your screen")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h2', {
    staticClass: "title"
  }, [_c('em', {
    staticClass: "far fa-life-ring"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "text-center show-for-large"
  }, [_vm._v("\n      WWF-Australia takes all complaints and feedback seriously. For information about our Complaint Handling Process, please\n      "), _c('a', {
    staticClass: "document pdf",
    attrs: {
      "href": "/ArticleDocuments/391/doc-policy-wwfaus-complaint-handling-jul18.pdf.aspx",
      "target": "_blank"
    }
  }, [_vm._v("\n        click here\n        "), _c('span', {
    staticClass: "file-info"
  }, [_vm._v("\n           (\n          "), _c('span', {
    staticClass: "file-type"
  }, [_vm._v("PDF")]), _vm._v(" \n          "), _c('span', {
    staticClass: "file-size"
  }, [_vm._v("380.6KB")]), _vm._v(")\n        ")])]), _vm._v(".\n    ")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c828248e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-webpack-plugin/loader.js?id=bhy68egj1x!./~/string-replace-webpack-plugin/loader.js?id=wgppdwdx8dq!./src/components/ContactUs.vue
// module id = 663
// module chunks = 0